import React from 'react';
import { Row } from 'antd';
import { FormField, maxLength, alphaNumeric } from 'common';

const warnHouse = [maxLength(30)];
const warnStreet = [maxLength(30), alphaNumeric];
const warnApartment = [maxLength(10), alphaNumeric];

const AddressFormFields: React.FC<{
  tabNamePrefix: string;
  rowStyle: string;
  inputStyle: string;
  handleFieldFocus?: any;
  startingTabIndex?: number;
  includeApartmentNumberField?: boolean;
  fieldsDisabled?: boolean;
  index?: number;
}> = ({
  tabNamePrefix,
  rowStyle,
  inputStyle,
  handleFieldFocus,
  includeApartmentNumberField = true,
  startingTabIndex = 0,
  fieldsDisabled = false,
  index = 0,
}) => {
  let tabIndex = startingTabIndex;
  const getNextTabIndex = (): number => {
    if (tabIndex === 0) return tabIndex;
    return (tabIndex += 100);
  };

  return (
    <>
      <Row key={index} type="flex" align="middle" className={rowStyle}>
        <FormField
          tabIndex={startingTabIndex}
          disabled={fieldsDisabled}
          onFocus={handleFieldFocus}
          warn={warnHouse}
          label="House Number"
          name={`${tabNamePrefix}.houseNumber`}
          tooltip="House Number"
          className={inputStyle}
        />
        <FormField
          tabIndex={getNextTabIndex()}
          disabled={fieldsDisabled}
          onFocus={handleFieldFocus}
          warn={warnStreet}
          label="Street"
          name={`${tabNamePrefix}.street`}
          tooltip="Street"
          className={inputStyle}
        />
        {includeApartmentNumberField && (
          <FormField
            tabIndex={getNextTabIndex()}
            disabled={fieldsDisabled}
            onFocus={handleFieldFocus}
            warn={warnApartment}
            label="Apartment"
            name={`${tabNamePrefix}.apartmentNumber`}
            tooltip="Apartment"
          />
        )}
      </Row>
    </>
  );
};

export default React.memo(AddressFormFields);
